// extracted by mini-css-extract-plugin
export default {"Footer":"footer_Footer__gFMKQ"};